import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const navigate = useNavigate();
	

/*
had an error with sessionStorage.getItem("RESTURL") returning null 
when below declaration was before this const RenderWpForm
*/
const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;


//getresturl();



window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const navWpform = React.useRef();
const navWpvouchers = React.useRef();
const [laborclrstatus, setLaborclrstatus] = useState([]);
const [tblgovtappspurge, setTblgovtappspurge] = useState([]);
const [arrmonthspan, setArrmonthspan] = useState([]);

const [lcsearchcrit, setLcsearchcrit] = useState({txt:"", dates: "", appstatus:"", apptype:"", filteruser:""});
const [combotype, setCombotype] = useState([]);
const [agencyoptions, setAgencyoptions] = useState([]);
const [dowait, setDowait] = useState({show:true});
const [dowaitLC, setDowaitLC] = useState({show:true});

const [wptapp, setWptapp] = useState({WPT_APP_ID:''});
const [tblwptapps, setTblwptapps] = useState({
loaded:false
,newrows:[]
,procrows:[]
,lcupdatedrows:[]
,rfsdrows:[]
});
const [linkwpform, setLinkwpform] = useState({WPT_APP_ID:0});
const [linkvouchers, setLinkvouchers] = useState({WPT_APP_ID:0});
const [searchcrit, setSearchcrit] = useState({
	txt: sessionStorage.getItem("searchcrit.txt")??""
	, cw:sessionStorage.getItem("ASSIGNED_TO_CW")??""
	, months_span: ""
	, YRMM1: ""
	, YRMM2: ""
	, processarea: "Government"
	, tcisland: sessionStorage.getItem("TC_ISLAND")??"PROVIDENCIALES"
	, AGENCY:""
	
	});
const [combodates, setCombodates] = useState([]);
const [tbllcrprocess, setTbllcrprocess] = useState([]);
const [tcislandopts, setTcislandopts] = useState([]);

const [processareaopts, setProcessareaopts] = useState([
<option value='' ></option>
,<option value='General' >General</option>
,<option value='Corporate' >Corporate</option>
]);


const startupMins='05';//here on test page this will be 10 seconds
let numticks=0;
const [ticks, setTicks] = useState({num:0});
const [city, setCity] = useState({name:''});

const [countdown, setCountdown] = useState({min:startupMins,sec:'00'});



const location = useLocation();
let reloadTimer=null;
//var currmins=10;
const timerEvent = () => {
	numticks+=1;
	const newticks=numticks;
	//console.log('numticks:'+numticks);
	//console.log('newticks:'+newticks);
	setTicks({num:newticks});
};


useEffect(() => {
//console.log('useEffect resturl: '+sessionStorage.getItem("RESTURL"));

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if


document.title =   "APS Applications";	
getarrmonthspan();
/*
setSearchcrit((prev)=>{
	console.log("PROCESS_AREA "+sessionStorage.getItem("PROCESS_AREA"));
	return {...prev, processarea:sessionStorage.getItem("PROCESS_AREA")}
	});

*/

console.log("reloadTimer: "+reloadTimer);
if (reloadTimer==null)
	reloadTimer = setInterval(timerEvent, 1000);//*60
else{

	}//end else

// Stops the old timer when umount the component.
return function stopTimer() {
	  console.log("cleaning up");
  clearInterval(reloadTimer);
}


 },[]);



useEffect(() => {

if (countdown.min==startupMins && countdown.sec=='00'){
	
	/*reload the table either directly or by clearing criteria*/
	if (searchcrit.txt=="" && searchcrit.months_span!="")
		gettblwptapps();
	else
		setSearchcrit((prev)=>{	return {...prev, txt:""} });
	
	
	//if (city.name=='')
		//openDefaultCity();
	}//end if
	
	
//console.log("ticks.num: "+ticks.num);
	if (1*countdown.min==0 && countdown.sec=='01')
		setCountdown({min:startupMins,sec:'00'});
	else{
		const newsec=countdown.sec=='00'?59:(1*countdown.sec)-1;
		const tempmin=1*countdown.min-((newsec==59)?1:0);
		//console.log("tempmin: "+tempmin);
		const newmin=tempmin<0?(1*startupMins)-1:tempmin;
		const padd=newsec<10?"0":"";
		setCountdown({min:""+newmin,sec:padd+newsec});
		}

 },[ticks.num]);





useEffect(() => {

if (combodates.length>0 && searchcrit.months_span==""){
	//const FIRST_MONTHS_SPAN = document.getElementsByName("FIRST_MONTHS_SPAN")[0].value;
	setSearchcrit((prev)=>{
		return {...prev
			, months_span: arrmonthspan[0].MONTHS_SPAN
			, YRMM1: arrmonthspan[0].YRMM1
			, YRMM2: arrmonthspan[0].YRMM2
			}
		});
	}//end if
	

 },[JSON.stringify(combodates)]);
	

useEffect(() => {

if (arrmonthspan.length>0 && combodates.length==0)
	writeCombodates();

 },[JSON.stringify(arrmonthspan)]);
 
 
 useEffect(() => {
	 if (dowait.show==false)
		openDefaultCity();
 },[dowait.show]);
 
 useEffect(() => {
	if (linkwpform.WPT_APP_ID>0)
		navWpform.current?.click();
 },[linkwpform]);

 

useEffect(() => {
	if (linkvouchers.WPT_APP_ID>0)
		navWpvouchers.current?.click();
 },[linkvouchers]);


useEffect(() => {
	
	
	
/*
console.log("city.name: "+city.name);
	if (city.name=="lcrprocesstc")
		if (laborclrstatus.length==0 || combotype.length==0){
			getlcrstartoptions();
			}//end if
*/
		
 },[city.name]);


/*
useEffect(() => {
	if (laborclrstatus.length>0 && combotype.length>0){
		getbllcrprocess();
		}//end if
		
 },[ JSON.stringify(laborclrstatus), JSON.stringify(combotype), lcsearchcrit ]);

*/


useEffect(() => {
	
	if (searchcrit.months_span=="")
		return;
	
	console.log("useEffect searchcrit: "+JSON.stringify(searchcrit));
	gettblwptapps();

 },[searchcrit]);


useEffect(() => {
	if (tblwptapps.loaded==true && agencyoptions.length==0)
		getlcrstartoptions();

 },[JSON.stringify(tblwptapps.loaded)]);
 


async function getlcrstartoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarwptprocess/getlcrstartoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlcrstartoptions(res) )
      .catch(err => console.log(err));

}//end func



function aftergetlcrstartoptions(res){
	console.log("aftergetlcrstartoptions res.length: "+res.length);
//copied from lcrprocess.js
let tempcombotype=[];
let tempstatusoptions=[];
let tempagencyopts=[];
let temptcislandopts=[];


res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const opt=col['OPT'];
	const val=col['VAL'];
	
	
	if (combo=='status')
		tempstatusoptions.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='lctype')//wptype
		tempcombotype.push(<option key={key} value={val}  >{opt}</option>);
	else if (combo=='agency')//agency
		tempagencyopts.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='location' && (opt=="PROVIDENCIALES"||opt=="GRAND TURK") )
		temptcislandopts.push(<option key={key} value={opt}  >{opt}</option>);	

	});//end map

console.log("tempagencyopts.length: "+tempagencyopts.length);

setTcislandopts(temptcislandopts);
setCombotype(tempcombotype);
setAgencyoptions(tempagencyopts);
}//end func






async function getarrmonthspan(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

setCombodates([]);
setArrmonthspan([]);

  await fetch(resturl+'rarwpform/getcombodates',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetarrmonthspan(res) )	
	
}//end func


function aftergetarrmonthspan(res){
	
	
let temp=[];

res.map((col, index) => {
	temp.push({
		YRMM1: col['YRMM1']
		,YRMM2: col['YRMM2']
		,MONTHS_SPAN: col['MONTHS_SPAN']
		});

	//if (index==0)
		//document.getElementsByName("FIRST_MONTHS_SPAN")[0].value=col['MONTHS_SPAN'];

	});//end map

setArrmonthspan(temp);
	
}//end func

function writeCombodates(){
	
	
let temp=[];

arrmonthspan.map((col, index) => {
	const key="months_span_"+index;
	const MONTHS_SPAN = col['MONTHS_SPAN'];
	temp.push(<option key={key} value={MONTHS_SPAN}  >{MONTHS_SPAN}</option>);

	});//end map

setCombodates(temp);
	
}//end func




async function getbllcrprocess(){
const EMAIL=sessionStorage.getItem("EMAIL");
console.log('EMAIL: '+EMAIL);
const USERNAME=sessionStorage.getItem("USERNAME")==undefined?sessionStorage.getItem("EMAIL"):sessionStorage.getItem("USERNAME");

//let tempsearchcrit=searchcrit;
//tempsearchcrit.apptype=lcsearchcrit.apptype
//const [lcsearchcrit, setLcsearchcrit] = useState({txt:"", dates: "", appstatus:"", apptype:"", filteruser:""});
let crit =lcsearchcrit;//only appstatus and apptype are avail initially
//txt:'', cw:'', dates: 
crit.txt=searchcrit.txt;
crit.dates=searchcrit.months_span;
crit.filteruser=searchcrit.cw;

const params={
	USERNAME:USERNAME
, crit: crit
, DATES: searchcrit.months_span
}

console.log("getbllcrprocess: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowaitLC({show:true});
setTbllcrprocess([]);

  await fetch(resturl+'rarwptprocess/gettbllaborclr',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetbllcrprocess(res) )
      .catch(err => console.log(err));

}//end func


function aftergetbllcrprocess(res){
	
	console.log("aftergetbllcrprocess res.length: "+res.length);
	
	setDowaitLC({show:false});
	
if (!res.length)
	return;

let htmrows=[];

	res.map((col, index) => {
		
		const key="tbllcrproc_"+index;
		const LBR_CLR_APP_ID=col['LBR_CLR_APP_ID'];
		const MPE_NAME=col['MPE_NAME'];
		const openLink=<a href="#" className="nodecor" target="_blank" onClick={(e)=>{openlaborclr(e, LBR_CLR_APP_ID);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{MPE_NAME}</a>;
	
		const htmrow=<tr key={key} >
					<td align="right" >{index+1}</td>
					<td align="right" >{LBR_CLR_APP_ID}</td>
					<td align="left" >{col['CREATED_DATE']}</td>
					<td align="left" >{col['IMG_REF_NO']}</td>
					<td align="left" >{openLink}</td>
					<td align="left" >{col['APP_TYPE']}</td>
					<td align="left" >{col['STATUS']}</td>
					<td align="left" >{col['OCCUPATION']}</td>
					<td align="left" >{col['EXP_DATE']}</td>
					<td align="left" >{col['MPR_NAME']}</td>
					</tr>;
		htmrows.push(htmrow);
		
		});//end map

setTbllcrprocess(htmrows);
	
}//end func

function openlaborclr(e, LBR_CLR_APP_ID){
	
	console.log("openlaborclr LBR_CLR_APP_ID: "+LBR_CLR_APP_ID);
	
	e.preventDefault();
	//navigate("/lcrprocess", {state:{"BACK_PAGE":"/wpapps", LBR_CLR_APP_ID:LBR_CLR_APP_ID}});
	document.getElementsByName("LBR_CLR_APP_ID")[0].value=LBR_CLR_APP_ID;
	const win = window.open("lcrprocess");
	//win.document.append("LBR_CLR_APP_ID: <input name='LBR_CLR_APP_ID' value='"+LBR_CLR_APP_ID+"' />");

	
}//end func


function openDefaultCity(){
	
if (document.getElementById('newapps')){

	//console.log("evt.currentTarget.className: "+evt.currentTarget.className);newrows?.length
	let cityName="", elemId="";
	if (tblwptapps.newrows?.length>0){
		cityName="newappstc";
		elemId="newapps";
		}//end if
	else if (tblwptapps.procrows?.length>0){
		cityName="processingappstc";
		elemId="processingapps";
		}//end if
	else if (tblwptapps.lcupdatedrows?.length>0){
		cityName="lcupdatedappstc";
		elemId="lcupdatedapps";
		}//end if
	else if (tblwptapps.rfsdrows?.length>0){
		cityName="refusedappstc";
		elemId="refusedapps";
		}//end if
	else {
		cityName="newappstc";
		elemId="newapps";
		}//end if		
	
	const evt={
	currentTarget:document.getElementById(elemId)
	};
	openCity(evt, cityName);
	//smith
	}//end if	
	
}//end func

function getresturl(){
console.log('getresturl( location.state: '+JSON.stringify(location.state))	;
for(var attributename in location.state){
	if (attributename=='resturl')
		return location.state.resturl;
	}//end for	
return null;	
}//end func





async function gettblgovtappspurge(e){
	e.preventDefault();
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {dates:searchcrit.months_span} )
  };		

setTblgovtappspurge([]);

 await fetch(resturl+'rarwpform/gettblgovtappspurge',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertblgovtappspurge(res) )	
	
}//end func

function aftertblgovtappspurge(res){

if (!res.length){
	console.log("abort aftertblgovtappspurge for empty res");
	return;
	}

let temprows=[];
res.map((col, index) => {
	const key="purge"+index;
		
	temprows.push(
		<tr key={key} >
		<td align='right' >{index+1}</td>
		<td align='right' >{col['WORK_PERMIT_ID']}</td>
		<td align='left' >{col['FIRST_NAME']}</td>
		<td align='left' >{col['LAST_NAME']}</td>
		<td align='left' >{col['EMPLOYER']}</td>
		<td align='left' >{col['OCCUPATION']}</td>
		<td align='center' >{col['PASSPORT_NO']}</td>
		<td align='center' >{col['DOB']}</td>
		</tr>);
	
	});//end map

console.log("temprows.length: "+temprows.length);
setTblgovtappspurge(temprows);

}//end func


async function setCaseWorker(e){
	e.preventDefault();
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), WPT_APP_ID:wptapp.WPT_APP_ID} )
  };		

 await fetch(resturl+'rarwpform/setcaseworker',requestOptions)
      .then(res => res.json())
      .then(res => 	afterSetCaseWorker(res) )	
	
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function afterSetCaseWorker(res){
if (res.length==undefined)
	showsnackbar("something went wrong.  please try again");
else{	
	showsnackbar("assigning case worker is complete");
	toggleModalsm();
	}
}//end func

function assignedToMe(e){
const USERNAME=sessionStorage.getItem("USERNAME");	
let caseworker=(e.target.checked==true)?USERNAME:"";
setSearchcrit((prev)=>{
	return {...prev, cw:caseworker}
});
sessionStorage.setItem("ASSIGNED_TO_CW", caseworker);

}//end func


function viewwpform(e, WPT_APP_ID){
console.log('viewwpform WPT_APP_ID: '+WPT_APP_ID);
e.preventDefault();
setLinkwpform({WPT_APP_ID:WPT_APP_ID});
	{/*
	setLinkwpform();
if (navWpform.current)
	navWpform.state={WPT_APP_ID:WPT_APP_ID};
navWpform.current?.click();

	*/}

}//end func


async function gettblwptapps(){
const EMAIL=sessionStorage.getItem("EMAIL");
console.log('EMAIL: '+EMAIL);
const USERNAME=sessionStorage.getItem("USERNAME")==undefined?sessionStorage.getItem("EMAIL"):sessionStorage.getItem("USERNAME");

const ASSIGNED_TO_CW=sessionStorage.getItem("ASSIGNED_TO_CW")?sessionStorage.getItem("ASSIGNED_TO_CW"):"";
let CASE_WORKER=searchcrit.cw;//searchcrit.cw can be override by session
if (CASE_WORKER=="" && ASSIGNED_TO_CW!="")
	CASE_WORKER=ASSIGNED_TO_CW;


let params=searchcrit;
//params.STATUS=tabmenu.STATUS;
params.USERNAME=USERNAME;
params.CASE_WORKER=sessionStorage.getItem("CASE_WORKER")??"";

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowait({show:true});
setTblwptapps([]);

  await fetch(resturl+'rarwpform/gettblwptapps',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwptapps(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblwptapps(res){

setDowait({show:false});

	
console.log('aftergettblwptapps, res.length: '+res.length);

let newrows=[], procrows=[], rfsdrows=[], lcupdatedrows=[], completedrows=[];

res.map((col, index) => {
	if (index==0 && document.getElementsByName("combodates")[0]){
		//--if there is exact match of REF_NUM, IMG_REF, PASSP_NBR OR NAME, we can skip the date filter
		document.getElementsByName("combodates")[0].disabled=false;
		const CRIT_MATCH_COUNT=col['CRIT_MATCH_COUNT'];
		console.log("CRIT_MATCH_COUNT: "+CRIT_MATCH_COUNT);
		 if (CRIT_MATCH_COUNT)
			 if (CRIT_MATCH_COUNT>0)
				 document.getElementsByName("combodates")[0].disabled=true;
				 
		}//end if
		
	
	const appid=col['WPT_APP_ID'];
	const refnum=col['REF_NUM'];
	const STATUS=col['STATUS_CODE'];
	const CORPORATE=col['CORPORATE'];
	const CASE_WORKER=col['CASE_WORKER'];
	const submitted=col['SUBMITTED_TO_CSC'];
	const VOUCHERS_TOTAL_AMT=(col.VOUCHERS_TOTAL_AMT==null)?'':'$'+col.VOUCHERS_TOTAL_AMT;
	
	/*
const LATE_ALERT=!col['LATE_ALERT']?<img src="img/orangealert.png" border="0" style={{visibility:"hidden"}} />:<img src="img/orangealert.png" border="0" title="this application has not been processed after some time" />;
	console.log("LATE_ALERT: "+col['LATE_ALERT']);	
	*/
	
	//const viewed = col['STR_VIEWED_DATE_TIME'];
	const trkey='tr_'+appid;
	//const rdkey='rd_'+appid;
		
	const refnumLink=<a href="#" className="nodecor" onClick={(e)=>{handleWpappChange(e, appid);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{refnum}</a>;
		{/*<span className='tooltiptext'>open this application</span>*/}
	//const voucherLink=<a href="#" className="nodecor" onClick={(e)=>{vouchersLink(e, appid);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{VOUCHERS_TOTAL_AMT}<span className='tooltiptext'>vouchers and payment</span></a>;
	
	//const pdflink=sessionStorage.getItem("UPLOADURL")+refnum+"/coverpage.pdf";	
	
	{/* <td align='left' className='tooltip' >&nbsp;{refnumLink}</td> */}
	
	
	const htmrow=<tr key={trkey} >
	<td align='left' >&nbsp;{refnumLink}</td>
	<td align='left' >{col['INITIALS']}</td>
	<td align='left' >{col['STATUS']}</td>
	<td align='center' >{col['SUBMITTED_TO_CSC']}</td>
	<td align='left' >{col['APP_TYPE']}</td>
	<td align='left' >{col['AGENCY']}</td>
	<td align='left' >{col['MPR_NAME']}</td>
		{/*<td align='left' >{col['MPR_TEL_NBR']}</td>*/}
	<td align='left' >{col['IMG_REF']}</td>
	<td align='left' >{col['MPE_NAME']}</td>
	<td align='left' >{col['MPE_OCCUPATION']}</td>
		{/*<td align='right' className="tooltip" >{voucherLink}&nbsp;</td>*/}
	<td align='center' >{col['VIEWED_DATE_TIME']}</td>
	</tr>;
	if (STATUS=='NEW' || STATUS=='NOTSUBMIT')
		newrows.push(htmrow);
	else if (STATUS=='VCHRSPAID' || STATUS=='REVIEWED')
		procrows.push(htmrow);
	else if (STATUS=='REFUSED' || STATUS=='CANCELLED')
		rfsdrows.push(htmrow);
	else if (STATUS=='COMPLETED')
		completedrows.push(htmrow);
	else{
		lcupdatedrows.push(htmrow);
		/*
		The below if condition is removed so to capture all other status in this category
		we also have DENIED, AWAITING APPROVAL, and who knows what else
		if (STATUS=='PROCESSING' || STATUS=='DEFERRED' || STATUS=='WITHDRAWN' || STATUS=='APPROVED')
			SP_WPT_APP_STATUS_FRM_LCR
		*/ 
		}
		
	});



setTblwptapps({
loaded:true
,newrows:newrows	
,procrows:procrows	
,lcupdatedrows:lcupdatedrows
,completedrows:completedrows
,rfsdrows:rfsdrows
});



}//end func

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

	if (evt.currentTarget)
		evt.currentTarget.className += " active";
	
  setCity({name:cityName});
}//end func

function vouchersLink(e, appid){
	console.log('setLinkvouchers '+appid);
	e.preventDefault();
	setLinkvouchers({WPT_APP_ID:appid});

}//end func


function handleWpappChange(e, WPT_APP_ID){
	e.preventDefault();
	navigate("/gvtform",{state:{WPT_APP_ID:WPT_APP_ID}});
}//end func


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func


function searchcritChange(e){
	
const {name, value}=e.target;

setSearchcrit(prev=>{	return {...prev, [name]:e.target.value} }); 
	
sessionStorage.setItem("searchcrit."+name, value);


let temp_months_span={YRMM1: searchcrit.YRMM1, YRMM2: searchcrit.YRMM2};
if (name=="months_span"){
	for (var i=0; i<arrmonthspan.length; i++)
		if (arrmonthspan[i].MONTHS_SPAN==value){
			temp_months_span.YRMM1=arrmonthspan[i].YRMM1;
			temp_months_span.YRMM2=arrmonthspan[i].YRMM2;
			}//end if
	
	}//end if

setSearchcrit((prev)=>{	
	return {...prev
		, [name]:value
		, critname: name
		, YRMM1: temp_months_span.YRMM1
		, YRMM2: temp_months_span.YRMM2
		}
	}); 
	
}//end func

function handleSearchCritChange(e){

setSearchcrit((prev)=>{	return {...prev, txt:e.target.value} });;
setLcsearchcrit((prev)=>{	return {...prev, txt:e.target.value} });;
	
}//end func

function lccritChange(e){
		var {name, value}=e.target;
//console.log("handleChange name: "+name+" -> "+value);	
//document.getElementById('btnsave').style.visibility='visible';

setLcsearchcrit((prev)=>{
	return {...prev, [name]:value}
});


}//end func
	
const theadcells=<>
	<tr>
		<th>WP portal ref #</th>
		<th>Case<br/>Worker</th>
		<th>status</th>
		<th>submitted</th>
		<th>app type</th>
		<th>
			<select  value={searchcrit.AGENCY} onChange={(e)=>{setSearchcrit((prev)=>{return {...prev, AGENCY:e.target.value}})}} style={{width:"200px"}} >
			<option value='' >* * * agencies * * *</option>
			{agencyoptions}
			</select>
		</th>
		<th>employer's name</th>
		{/*<th>employer's phone #</th>*/}
		<th>Immig #</th>
		<th>applicant</th>
		<th>job title</th>
		<th>first viewed</th>
	</tr>

</>;

const ASSIGNED_TO_CW=sessionStorage.getItem("ASSIGNED_TO_CW")?sessionStorage.getItem("ASSIGNED_TO_CW"):"";
let cbastome="";
if (ASSIGNED_TO_CW!="")
	cbastome="checked";

const AD_USER=sessionStorage.getItem("AD_USER")??"";

	//console.log("AD_USER: " + AD_USER);
	{/*<a href="#" onClick={(e)=>{e.preventDefault();navigate("/wptappstoemail");}} ><img src="img/emaillg.png" border="0" height="28" /><span className='tooltiptext'>open email queue</span></a>*/}
	
  return (
    <>

<table align='center' border="0" width="87%" style={{marginTop:"10px", marginBottom:"10px"}}>
<tbody>
<tr>
<td><select name="months_span" value={searchcrit.months_span} onChange={(e)=>{searchcritChange(e);}} >{combodates}</select></td>
<td>&nbsp;</td>
<td align='center' className='tooltip' >
{
AD_USER!="" &&	
<><input id="cbastome" checked={cbastome} onClick={(e)=>{assignedToMe(e);}} type="checkbox" onChange={(e)=>{}} /><label htmlFor="cbastome" className="hand" >assigned to me</label></>
}
</td>
<td align='center' >
search criteria:&nbsp;<input name="searchcrit" size='30' defaultValue={searchcrit.txt} autoComplete="off" style={{textAlign:"center"}} onChange={(e)=>{handleSearchCritChange(e);}} onFocus={(e)=>{e.target.select();}} 
title="'Immig. Ref # / Portal Ref # / Passport # / Name / Job Title'"
placeholder='Immig. Ref # / Portal Ref # / Passport # / Name / Job Title' />

</td>
<td>
{
AD_USER!="" &&	
<select name="tcisland" value={searchcrit.tcisland} onChange={(e)=>{searchcritChange(e);}} style={{width:"80px"}} >{tcislandopts}</select>
}
</td>
<td align='center' className='tooltip' ><input size="2" name="inputminsremain" value={countdown.min+':'+countdown.sec} style={{textAlign:"center"}} readOnly className="gnsbro" /><span className='tooltiptext'>minutes before reload</span></td>

<td align='center'  >
<a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/cancelwptapps");  }} ><img src='img/trash.png' border='0' />defer or cancel</a>
</td>
</tr>
</tbody>
</table>
	
{dowait.show && <div align='center' ><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}	
{!dowait.show && <>
<div className="tab">
  <button className="tablinks" id='newapps'    onClick={(e)=>{openCity(e, e.target.id+"tc");}} >New Applications <span className="brown" >{tblwptapps.newrows?.length}</span></button>
  <button className="tablinks" id='processingapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Reviewed <span className="brown" >{tblwptapps.procrows?.length}</span></button>
  <button className="tablinks" id='lcupdatedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Processing <span className="brown" >{tblwptapps.lcupdatedrows?.length}</span></button>
  <button className="tablinks" id='completedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Completed <span className="brown" >{tblwptapps.completedrows?.length}</span></button>
  <button className="tablinks" id='refusedapps'   onClick={(e)=>{openCity(e, e.target.id+"tc");}} >Refused <span className="brown" >{tblwptapps.rfsdrows?.length}</span></button>
  
</div>




<div id="newappstc" className="tabcontent">
  <h4 align='center' >Newly Submitted Applications to be checked.  After checking, payment vouchers prepared if the applicaiton is not refused</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblwptapps.newrows}
	</tbody>
	</table>
</div>


<div id="processingappstc" className="tabcontent">
  <h4 align='center' >Applications with status Paid or Reviewed</h4>
  <div align="center">If Paid application does not move to Reveiewed automatically, that means there is a problem exporting the paid application.</div>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblwptapps.procrows}
	</tbody>
	</table>
</div>	


<div id="lcupdatedappstc" className="tabcontent">
  <h4 align='center' >Applications with status updated from Labor Clearance System. i.e. Processing, Approved, etc.</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblwptapps.lcupdatedrows}
	</tbody>
	</table>
</div>	


<div id="completedappstc" className="tabcontent">
  <h4 align='center' >COopleted Applications</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblwptapps.completedrows}
	</tbody>
	</table>
</div>	


<div id="refusedappstc" className="tabcontent">
  <h4 align='center' >Refused or Cancelled Applications</h4>
	<table align='center' className='customers'  >
	<thead>
	{theadcells}
	</thead>
	<tbody>
		{tblwptapps.rfsdrows}
	</tbody>
	</table>
</div>	
</>
}



	{AD_USER!="" && tblwptapps.newrows?.length>0 && <div align="center" ><a href="#" onClick={(e)=>{ gettblgovtappspurge(e); }} >check for applications already processed</a></div>}
	
	{
	tblgovtappspurge.length>0 &&
	<table align="center" class="customers" >
	<thead>
	<tr>
	<th align="right" >#</th>
	<th align="right" >Id #</th>
	<th align="left" >First Name</th>
	<th align="left" >Last Name</th>
	<th align="left" >Employer</th>
	<th align="left" >Occupation</th>
	<th align="center" >Passport #</th>
	<th align="center" >DOB</th>
	</tr>
	</thead>
	<tbody>
		{tblgovtappspurge}
	</tbody>
	</table>
	}

	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			
			<p>you are not currently the case worker assigned to this application</p>
			<p>click the second button below if you will be the case worker assigned</p>
			<p>
			<button className="button" onClick={(e)=>{ toggleModalsm(); }} >Cancel</button>
			&nbsp;&nbsp;
			<button className="button" onClick={(e)=>{ setCaseWorker(e); }} >I will be the case worker assigned</button>
			</p>
			
			</div>
		</div>
	</div>

<div id="snackbar">&nbsp;</div>
          <NavLink
		  ref={navWpform}
          to={"/gvtform"}
		  style={{display:"none"}}
          state={{
		  WPT_APP_ID:linkwpform.WPT_APP_ID
		  }} 
        >
		&nbsp;click here to wpform
        </NavLink>

          <NavLink
		  ref={navWpvouchers}
          to={"/wpvouchers"}
		  style={{display:"none"}}
          state={{
		  WPT_APP_ID:linkvouchers.WPT_APP_ID
		  }} 
        >
		&nbsp;click here to vouchers
        </NavLink>
		{/*
		
        <NavLink ref={navWpform} to={"/wpform"} style={{display:"none"}}
          state={{WPT_APP_ID:0}}  >wpform</NavLink>
		*/}



    </>
  );
  


};


export default RenderWpForm;